module.exports = __webpack_public_path__ + "img/noticeoff.f56c056e.png";